"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Skin = void 0;
const _1 = require(".");
class Skin extends _1.DefaultModel {
    constructor(name, group, title, description, chain_id, contract_address, contract_whitelisted, is_default, skin_token_ids) {
        super();
        this.name = name;
        this.group = group;
        this.title = title;
        this.description = description;
        this.chain_id = chain_id;
        this.contract_address = contract_address;
        this.contract_whitelisted = contract_whitelisted;
        this.is_default = is_default;
        this.skin_token_ids = skin_token_ids;
    }
    static getValidationMap() {
        return Object.assign({ name: 'string', group: 'string', title: 'string', description: 'string', chain_id: 'string', contract_address: 'string', contract_whitelisted: 'bool', is_default: 'bool', skin_token_ids: 'array' }, super.getValidationMap());
    }
}
exports.Skin = Skin;
//# sourceMappingURL=skins.model.js.map